<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useRegDialog } from '@/composables/use-reg-dialog';

const router = useRouter();
const { state, closeLock } = useRegDialog();

const subject = computed(() => state.subject);

function confirm() {
  closeLock();
  // 报名成功后落到「我的考试」tab，而非默认的个人信息
  router.push({ path: '/user', query: { tab: 'exam' } });
}
</script>

<template>
  <div
    v-if="state.lockOpen"
    class="modal-overlay fixed inset-0 z-[2000] flex items-center justify-center p-6 bg-black/50 backdrop-blur-sm max-sm:p-3"
  >
    <div
      class="modal-box w-full max-w-[480px] max-h-[85vh] overflow-y-auto bg-surface-card border border-primary-light rounded-xl shadow-[0_24px_64px_rgba(0,0,0,0.25)] max-sm:max-h-[92vh]"
    >
      <div class="sticky top-0 z-[1] flex items-center justify-between p-5 bg-surface-card border-b border-border-subtle max-sm:p-4">
        <h3 class="text-text-primary text-lg font-bold">
          报名成功
        </h3>
        <button
          class="flex items-center justify-center size-8 rounded-full bg-muted text-text-tertiary text-lg transition-all hover:bg-primary-subtle hover:text-primary"
          aria-label="关闭"
          @click="closeLock"
        >
          ×
        </button>
      </div>

      <div class="p-6 max-sm:p-4">
        <div class="py-3 text-center">
          <div class="flex items-center justify-center size-16 mx-auto my-4 text-primary text-[32px] bg-primary-light rounded-full">
            ✓
          </div>
          <div class="mb-2 text-text-primary text-base font-bold">
            报名提交成功
          </div>
          <div class="mb-6 text-text-tertiary text-sm leading-relaxed">
            考位已为您锁定。资格审核完成后，结果将通过您填写的邮箱通知；考试费用请在考试当天于考点现场线下缴费。
          </div>

          <div v-if="subject" class="grid grid-cols-2 gap-4 mb-6 text-left max-sm:grid-cols-1">
            <div>
              <div class="mb-1 text-text-tertiary text-xs">
                报考科目
              </div>
              <div class="text-text-primary text-sm font-semibold">
                {{ subject.name }}
              </div>
            </div>
            <div>
              <div class="mb-1 text-text-tertiary text-xs">
                考试费用
              </div>
              <div class="text-text-primary text-sm font-semibold">
                {{ subject.fee }}
              </div>
            </div>
          </div>

          <div class="flex gap-3 justify-center mt-6 pt-5 border-t border-border-subtle">
            <button
              class="py-2.5 px-6 text-white font-semibold text-sm bg-primary border-none rounded-lg cursor-pointer transition hover:bg-primary-hover"
              @click="confirm"
            >
              我知道了
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-box {
  animation: cl-modal-in 0.3s ease;
}

@keyframes cl-modal-in {
  from {
    transform: scale(0.96) translateY(10px);
    opacity: 0;
  }

  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
</style>
